import React from 'react';

import Chip from '@material-ui/core/Chip';
import styled from 'styled-components';

import { AGENDA_TAG_LABEL_TYPES } from 'constants/ProjectConstants';

const StyledChip = styled(Chip)`
  height: 20px;
  border-radius: 4px;
  background-color: ${(props) => props.theme.palette.background.lightGrey3};
  color: ${(props) => props.theme.palette.text.blackV1};
`;

const AgendaTag = React.memo(({ labelType }) => {
  const handleClick = () => {};

  return <StyledChip label={AGENDA_TAG_LABEL_TYPES[labelType].displayName} onClick={handleClick} clickable={false} />;
});

export default AgendaTag;
